<div class="row section1">
  <div class="col-6 border-right">
    <div class="applicants-details details1 pt-0">
      <div class="row align-items-center">
        <div class="col single-user ">
          <p>
            <ngx-skeleton-loader [theme]="{ width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader>
          </p>
        </div>
        <div class="col-auto mb-3">
          <ngx-skeleton-loader [theme]="{ width:'100px', height: '100px', marginBottom: '0px', borderRadius: '50%'}"></ngx-skeleton-loader>
        </div>
      </div>
      <hr class="border2">
      <div class="row">
        <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user ">
          <p>
            <ngx-skeleton-loader [theme]="{ width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader>
          </p>
        </div>
        <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user user1">
          <p>
            <ngx-skeleton-loader [theme]="{ width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader>
          </p>
        </div>
      </div>
      <hr class="border2">
      <div class="row">
        <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user ">
          <p>
            <ngx-skeleton-loader [theme]="{ width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader>
          </p>
        </div>
        <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user user1">
          <p>
            <ngx-skeleton-loader [theme]="{ width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader>
          </p>
        </div>
      </div>
      <hr class="border2">
      <div class="row">
        <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user ">
          <p>
            <ngx-skeleton-loader [theme]="{ width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader>
          </p>
        </div>
        <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user user1">
          <p><ngx-skeleton-loader [theme]="{ width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader></p>
        </div>
      </div>
      <hr class="border2">
      <div class="row">
        <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user ">
          <p>
            <ngx-skeleton-loader [theme]="{ width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader>
          </p>
        </div>
        <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user user1">
          <p>
            <ngx-skeleton-loader [theme]="{ width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader>
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="col-6 pt-5">
    <div class="row">
      <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user">
        <p>
          <ngx-skeleton-loader [theme]="{ width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader>
        </p>
      </div>
      <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user user1">
        <p>
          <ngx-skeleton-loader [theme]="{ width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader>
        </p>
      </div>
    </div>
    <hr class="border2">
    <div class="row">
      <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user">
        <p>
          <ngx-skeleton-loader [theme]="{ width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader>
        </p>
      </div>
      <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user user1">
        <p>
          <ngx-skeleton-loader [theme]="{ width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader>
        </p>
      </div>
    </div>
    <hr class="border2">
    <div class="row">
      <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user ">
        <p>
          <ngx-skeleton-loader [theme]="{ width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader>
        </p>
      </div>
      <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user user1">
        <p>
          <ngx-skeleton-loader [theme]="{ width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader>
        </p>
      </div>
    </div>
    <hr class="border2">
    <div class="row">
      <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user ">
        <p>
          <ngx-skeleton-loader [theme]="{ width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader>
        </p>
      </div>
      <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user user1">
        <p>
          <ngx-skeleton-loader [theme]="{ width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader>
        </p>
      </div>
    </div>
    <hr class="border2">
    <div class="row">
      <div class="col-12 single-user ">
        <p><ngx-skeleton-loader [theme]="{ width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader></p>
        <div class="col-12">
          <div class="row">
            <div class="col">
              <p><ngx-skeleton-loader [theme]="{ width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader></p>
              <hr class="border2">
              <p><ngx-skeleton-loader [theme]="{ width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader></p>
              <hr class="border2">
              <p><ngx-skeleton-loader [theme]="{ width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader></p>
            </div>
            <div class="col-auto">
              <p class="text-orange"><a><ngx-skeleton-loader [theme]="{ width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader></a></p>
              <hr class="border2">
              <p class="text-orange"><a><ngx-skeleton-loader [theme]="{ width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader></a></p>
              <hr class="border2">
              <p class="text-orange"><a><ngx-skeleton-loader [theme]="{ width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader></a></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
